module.exports = __webpack_public_path__ + "img/83.c86e4296.png";